import * as React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import KnowledgeBase from "./KnowledgeBase";
import styles from "./KnowledgeBaseView.scss";
import LeftArrow from "components/icons/LeftArrow";
import { useTheme } from "utils/useTheme";

export default function KnowledgeBaseView(): JSX.Element {
    const { t } = useTranslation();
    const theme = useTheme();
    const history = useHistory();

    return (
        <div className={styles.knowledgeBaseView}>
            <div className={styles.knowledgeBaseBackBanner}>
                <button onClick={() => history.push("/home")} className={styles.knowledgeBaseBackButton}>
                    <LeftArrow color={theme.iconFillColor} />
                    {t("KnowledgeBase.backButton")}
                </button>
            </div>
            <div className={styles.knowledgeBaseContent}>
                <KnowledgeBase />
            </div>
        </div>
    );
}
